import React from 'react';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ReplayIcon from '@mui/icons-material/Replay';
import StarIcon from '@mui/icons-material/Star';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import ScheduleIcon from '@mui/icons-material/Schedule';
import GroupIcon from '@mui/icons-material/Group';
import {
    BenefitCard,
    BenefitContent,
    BenefitDesc,
    BenefitsGrid,
    BenefitsWrapper,
    BenefitTitle,
    IconBox,
    SectionTitle,
} from './styles';
import {useLandingContext} from "../../../Landing";

const iconsList = [
    <TrendingUpIcon key="1"/>,
    <ReplayIcon key="2"/>,
    <StarIcon key="3"/>,
    <LightbulbIcon key="4"/>,
    <ScheduleIcon key="5"/>,
    <GroupIcon key="6"/>,
];

export default function Benefits() {
    const {APP_DATA} = useLandingContext();

    return (
        <BenefitsWrapper>
            <SectionTitle>{APP_DATA.benefitsTitle}</SectionTitle>
            <BenefitsGrid>
                {APP_DATA.benefits.map((item, index) => (
                    <BenefitCard key={item.id}>
                        <IconBox>{iconsList[index % iconsList.length]}</IconBox>
                        <BenefitContent>
                            <BenefitTitle>{item.title}</BenefitTitle>
                            <BenefitDesc>{item.description}</BenefitDesc>
                        </BenefitContent>
                    </BenefitCard>
                ))}
            </BenefitsGrid>
        </BenefitsWrapper>
    );
}
